import { AwsExports } from './types';

const develop: AwsExports = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id:
    'us-east-2:5f6f1333-fd32-4e5d-bbc8-ec611d5b05cc',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_8N20NFvx5',
  aws_user_pools_web_client_id: '3nrjlogic95p1jlj70nutskkka',
  aws_appsync_graphqlEndpoint:
    'https://ugdzzt7oubbbzft6eukff3yjuq.appsync-api.us-east-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'publishGiide',
      endpoint:
        'https://xkynjzbn5c.execute-api.us-east-2.amazonaws.com/giidedev',
      region: 'us-east-2',
    },
  ],
  aws_user_files_s3_bucket: 'recordingsdesktop-develop',
  aws_user_files_s3_bucket_region: 'us-east-2',
  aws_dynamodb_all_tables_region: 'us-east-2',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'UserAccount-develop',
      region: 'us-east-2',
    },
  ],
};

const staging: AwsExports = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id:
    'us-east-2:5f6f1333-fd32-4e5d-bbc8-ec611d5b05cc',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_8N20NFvx5',
  aws_user_pools_web_client_id: '3nrjlogic95p1jlj70nutskkka',
  aws_appsync_graphqlEndpoint:
    'https://qerijs5qmva4fegt7j6d2c6emu.appsync-api.us-east-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'publishGiide',
      endpoint:
        'https://tf8tokuh3l.execute-api.us-east-2.amazonaws.com/develop',
      region: 'us-east-2',
    },
  ],
  aws_user_files_s3_bucket: 'recordingsdesktop-develop',
  aws_user_files_s3_bucket_region: 'us-east-2',
  aws_dynamodb_all_tables_region: 'us-east-2',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'UserAccount-develop',
      region: 'us-east-2',
    },
  ],
};

const production: AwsExports = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id:
    'us-east-2:32bbd306-1381-431e-935e-75cb151c4652',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_RmFljK3SA',
  aws_user_pools_web_client_id: '51sag1mvsn0nl64m22668fsgjh',
  aws_appsync_graphqlEndpoint:
    'https://cka7c34qkje55oklfxkmoy4uxq.appsync-api.us-east-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'publishGiide',
      endpoint:
        'https://1u5og7bb9g.execute-api.us-east-2.amazonaws.com/giideprod',
      region: 'us-east-2',
    },
  ],
  aws_user_files_s3_bucket: 'recordingsdesktop-giideprod',
  aws_user_files_s3_bucket_region: 'us-east-2',
  aws_dynamodb_all_tables_region: 'us-east-2',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'UserAccount-develop',
      region: 'us-east-2',
    },
  ],
};

function get(profileName: string): AwsExports {
  switch (profileName) {
    case 'develop':
      return develop;
    case 'giidepro':
      return develop;
    case 'staging':
      return staging;
    case 'production':
      return production;
    default:
      throw new Error(`Profile ${profileName} not found`);
  }
}

export const AwsProfiles = {
  get,
};
